import e, { Component as t } from "react";
import { Icon as n } from "../Icon/Icon.js";
import o from "../../../../node_modules/classnames/index.js";
import { Popover as r } from "../Popover/index.js";
import { closest as i } from "../../../utils/dom/index.js";
import { isEscKey as a } from "../../../constants/keyboard.js";
import { SelectableList as l } from "../../lists/SelectableList/index.js";
import { t as c } from "../../../i18/index.js";
function s(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function u(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function f(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function d(e) {
  return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function p(e, t) {
  return (p = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var b = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && p(e, t);
  }(v, t);
  var b,
    m,
    y,
    h = (b = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        n = d(v);
      if (b) {
        var o = d(this).constructor;
        t = Reflect.construct(n, arguments, o);
      } else t = n.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : s(this);
    });
  function v() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, v), e = h.apply(this, arguments), f(s(e), "state", {
      open: !1
    }), f(s(e), "containerRef", null), f(s(e), "close", function () {
      e.setState({
        open: !1
      });
    }), f(s(e), "handleToggle", function (t) {
      var n;
      (null === (n = t.target) || void 0 === n ? void 0 : n.type) !== "checkbox" && e.setState({
        open: !e.state.open
      });
    }), f(s(e), "handleGlobalKeydown", function (t) {
      a(t) && e.close();
    }), f(s(e), "handleGlobalClick", function (t) {
      i(t.target, {
        node: e.containerRef
      }) || e.close();
    }), f(s(e), "shouldDisableAllActions", function () {
      return 0 === e.props.selectedItemsNum;
    }), f(s(e), "handleItemClick", function (t) {
      return !("category" in t) && !t.disabled && !e.shouldDisableAllActions() && t.onClick();
    }), f(s(e), "getItemsWithClassNames", function () {
      return e.props.items.map(function (t) {
        var n, r;
        return n = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {},
              o = Object.keys(n);
            "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
              return Object.getOwnPropertyDescriptor(n, e).enumerable;
            }))), o.forEach(function (t) {
              f(e, t, n[t]);
            });
          }
          return e;
        }({}, t), r = r = {
          className: o("datatable__bulk-item", t.hasDivider && "datatable__bulk-item--has-divider", "category" in t ? {
            "datatable__bulk-category": !0
          } : {
            "datatable__bulk-action": !0,
            "datatable__bulk-action--danger": t.isDangerous,
            "datatable__bulk-action--disabled": t.disabled || e.shouldDisableAllActions()
          })
        }, Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : function (e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            n.push.apply(n, o);
          }
          return n;
        }(Object(r)).forEach(function (e) {
          Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(r, e));
        }), n;
      });
    }), f(s(e), "itemTemplate", function (e) {
      return "category" in e ? e.category : e.name;
    }), e;
  }
  return m = [{
    key: "componentDidMount",
    value: function value() {
      window.addEventListener("keydown", this.handleGlobalKeydown), window.addEventListener("click", this.handleGlobalClick, !0);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      window.removeEventListener("keydown", this.handleGlobalKeydown), window.removeEventListener("click", this.handleGlobalClick, !0);
    }
  }, {
    key: "render",
    value: function value() {
      var t = this;
      return e.createElement("div", {
        className: o("datatable__bulk-items", {
          "datatable__bulk-items--open": this.state.open
        }),
        onClick: this.handleToggle,
        ref: function ref(e) {
          return t.containerRef = e;
        }
      }, this.props.children, e.createElement(n, {
        "data-testid": "caret-icon",
        name: "caret-down",
        solid: !0
      }), e.createElement(r, {
        open: this.state.open,
        pointTo: "left",
        arrowPosition: "left",
        arrowSize: 0,
        edgeOffset: 0,
        spaceToTarget: 6,
        className: "datatable__bulk-items-popover"
      }, e.createElement("div", {
        "data-testid": "dropdown-title",
        className: o("datatable__bulk-items-title", {
          "datatable__bulk-items-title--has-divider": this.props.titleHasDivider
        })
      }, e.createElement("strong", null, this.props.selectedItemsNum), " ", c("selected")), e.createElement(l, {
        items: this.getItemsWithClassNames(),
        onItemPicked: this.handleItemClick,
        template: this.itemTemplate
      })));
    }
  }], u(v.prototype, m), y && u(v, y), v;
}(t);
f(b, "defaultProps", {
  titleHasDivider: !1
});
export { b as default };